import React, {useMemo} from 'react';

const SvgMaskWrapperStyle = {
    opacity: 0.45,
    color: '#000',
    width: '100%',
    left: 0,
    top: 0,
    height: '100%',
    position: 'fixed',
    zIndex: 99999
};

export default function SvgMask({
    targetWidth,
    targetHeight,
    targetTop,
    targetLeft,
    padding
}) {
    const windowWidth = useMemo(() => {
        return Math.max(
            document.documentElement.clientWidth,
            window.innerWidth || 0
        );
    }, [document.documentElement.clientWidth, window.innerWidth]);

    const windowHeight = useMemo(() => {
        return Math.max(
            document.documentElement.clientHeight,
            window.innerHeight || 0
        );
    }, [document.documentElement.clientHeight, window.innerHeight]);
    const safe = sum => (sum < 0 ? 0 : sum);
    const width = safe(targetWidth + padding * 2);
    const height = safe(targetHeight + padding * 2);
    const top = safe(targetTop - padding);
    const left = safe(targetLeft - padding);

    const roundedRadius = 10;

    return (
        <div style={SvgMaskWrapperStyle}>
            <svg
                width={windowWidth}
                height={windowHeight}
                xmlns="http://www.w3.org/2000/svg"
            >
                <defs>
                    <mask id="mask-main">
                        <rect
                            x={0}
                            y={0}
                            width={windowWidth}
                            height={windowHeight}
                            fill="white"
                        />
                        <rect x={left} y={top} width={width} height={height} fill="black" />
                        {/* top left rounded corner */}
                        <rect
                            x={left - 1}
                            y={top - 1}
                            width={roundedRadius}
                            height={roundedRadius}
                            fill="white"
                        />
                        <circle
                            cx={left + roundedRadius}
                            cy={top + roundedRadius}
                            r={roundedRadius}
                            fill="black"
                        />
                        {/* top right rounded corner */}
                        <rect
                            x={left + width - roundedRadius + 1}
                            y={top - 1}
                            width={roundedRadius}
                            height={roundedRadius}
                            fill="white"
                        />
                        <circle
                            cx={left + width - roundedRadius}
                            cy={top + roundedRadius}
                            r={roundedRadius}
                            fill="black"
                        />
                        {/* bottom left rounded corner */}
                        <rect
                            x={left - 1}
                            y={top + height - roundedRadius + 1}
                            width={roundedRadius}
                            height={roundedRadius}
                            fill="white"
                        />
                        <circle
                            cx={left + roundedRadius}
                            cy={top + height - roundedRadius}
                            r={roundedRadius}
                            fill="black"
                        />
                        {/* bottom right rounded corner */}
                        <rect
                            x={left + width - roundedRadius + 1}
                            y={top + height - roundedRadius + 1}
                            width={roundedRadius}
                            height={roundedRadius}
                            fill="white"
                        />
                        <circle
                            cx={left + width - roundedRadius}
                            cy={top + height - roundedRadius}
                            r={roundedRadius}
                            fill="black "
                        />
                    </mask>
                    <clipPath id="clip-path">
                        {/* top */}
                        <rect x={0} y={0} width={windowWidth} height={top} />
                        {/* left */}
                        <rect x={0} y={top} width={left} height={height} />
                        {/* right */}
                        <rect
                            x={targetLeft + targetWidth + padding}
                            y={top}
                            width={safe(windowWidth - targetWidth - left)}
                            height={height}
                        />
                        {/* bottom */}
                        <rect
                            x={0}
                            y={targetTop + targetHeight + padding}
                            width={windowWidth}
                            height={safe(windowHeight - targetHeight - top)}
                        />
                    </clipPath>
                </defs>
                <rect
                    x={0}
                    y={0}
                    width={windowWidth}
                    height={windowHeight}
                    fill="currentColor"
                    mask="url(#mask-main)"
                />
                <rect
                    x={0}
                    y={0}
                    width={windowWidth}
                    height={windowHeight}
                    fill="currentColor"
                    clipPath="url(#clip-path)"
                    pointerEvents="auto"
                />
                <rect
                    x={left}
                    y={top}
                    width={width}
                    height={height}
                    pointerEvents="auto"
                    fill="transparent"
                    display={'none'}
                />
            </svg>
        </div>
    );
}